/* created by CoolGuy on 2018/12/9 */
import React from 'react';
import BottomCommentSend from './BottomCommentSend';
import MultiFuncBottomArea from './MultiFuncBottomArea';
import { inject, observer } from 'mobx-react';

@inject('rootStore')
@observer
class BottomFixWrapper extends React.Component {
  clickBottomFixWrapper = e => {
    e.stopPropagation();
    const { bottomCommentStore } = this.props.rootStore;
    bottomCommentStore.toggleMultiBottom(false);
  };
  render() {
    const { bottomCommentStore, wxuserStore } = this.props.rootStore;
    const { showMultiBottom } = bottomCommentStore;
    // 为了让MultiFuncBottomArea显示出来的时候，评论不可滚动只好修改了bottom-fix-wrapper的position
    return (
      <div
        className="bottom-fix-wrapper not-login"
        onClick={this.clickBottomFixWrapper}
        style={{ position: showMultiBottom ? 'fixed' : 'static' }}
      >
        <div className="bottom-content" onClick={e => e.stopPropagation()}>
          {!wxuserStore.user.is_mock ? (
            <BottomCommentSend submit={this.props.submit} />
          ) : null}
          {showMultiBottom && <MultiFuncBottomArea />}
        </div>
      </div>
    );
  }
}

export default BottomFixWrapper;
